import { Stack, Typography } from "@mui/material";
import { ReactComponent as EiraInitLoader } from "../../assets/patientClinic/EiraHeader.svg";
import { useTranslation } from "react-i18next";

interface InitialLoaderProps {}

const InitialLoader: React.FC<InitialLoaderProps> = ({}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction={"column"}
      spacing={0}
      alignItems={"center"}
      height={"100vh"}
      justifyContent={"center"}
      sx={{
        backgroundColor: "rgba(252, 248, 248, 1)",
      }}
    >
      <Stack
        justifyContent={"center"}
        alignItems={"center"}
        maxHeight={"30%"}
        maxWidth={"40%"}
        spacing={2}
      >
        <EiraInitLoader
          style={{
            height: "70%",
            width: "70%",
          }}
        />
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "500",
            color: "rgba(37, 89, 74, 1)",
          }}
        >
          {t("eiraLoader")} {/* Fetching text from translation file */}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default InitialLoader;
